import {
  Server,
  Router,
  Cctv,
  Network,
  Monitor,
  Radio,
  HardDrive,
  Printer,
  Shield,
  Smartphone,
  Box
} from 'lucide-react';

export const PRIMARY_TABS = [
  { id: 'local_asset', label: 'EndPoint Servers', icon: Server },
  { id: 'switch', label: 'Switches', icon: Router },
  { id: 'camera', label: 'Cameras', icon: Cctv },
];

export const MORE_TYPES = [
  { id: 'network_device', label: 'Network Device', icon: Network },
  { id: 'unmanaged_switch', label: 'Unmanaged Switchs', icon: Router },
  { id: 'workstation', label: 'Workstations', icon: Monitor },
  { id: 'access_point', label: 'Access Points', icon: Radio },
  { id: 'nvr', label: 'NVR', icon: HardDrive },
  { id: 'printer', label: 'Printers', icon: Printer },
  { id: 'firewall', label: 'Firewalls', icon: Shield },
  { id: 'router', label: 'Routers', icon: Router },
  { id: 'storage', label: 'Storage Devices', icon: HardDrive },
  { id: 'mobile', label: 'Mobile', icon: Smartphone },
  { id: 'ilo', label: 'iLO', icon: Server },
  { id: 'other', label: 'Other', icon: Box }
];

export const ALL_ASSET_TYPE_OPTIONS = [
  ...PRIMARY_TABS.map((t) => ({ value: t.id, label: t.label, icon: t.icon })),
  ...MORE_TYPES.map((t) => ({ value: t.id, label: t.label, icon: t.icon })),
];
